// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2822":"839bfb816c1aa9e0","2888":"faa2068d7e2f623d","9998":"24406f722bc597eb"}[chunkId] + ".css";
};